import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { homeIntroducing } from "../../store/actions/homeContentAction";
import { unescapeHTML } from "../common/Common";

const NativeMobileApp = () => {
  const dispatch = useDispatch();
  const data_home = useSelector((state) => state.data_home_introducing);
  const { loading } = data_home;

  useEffect(() => {
    dispatch(homeIntroducing())
  }, [dispatch]);
  return (
    <>
      {!loading && data_home.data.isActive === 1 && (
        <div
          dangerouslySetInnerHTML={{
            __html: unescapeHTML(data_home.data.blockContent),
          }}
        ></div>
      )}
    </>
  );
};

export default NativeMobileApp;
